// Import of creatApp from Vue 3 bundler and axios for API requests.
import { createApp } from 'vue/dist/vue.esm-bundler';
import AgendaItem from './components/AgendaItem.vue';
import Skeleton from './components/Skeleton.vue';
import mixin from '../mixin.js';
import axios from 'axios';


const recommendationsApp = {
    components: { AgendaItem, Skeleton },
    mixins: [mixin],
    // The data object returns data-attribute values instantiated in HTML and general properties for loading state, 
    // the nested data object with resulting items.
    data() {
        return {
            dataApi: '',
            dataLimit: 4, // Default limit in BE
            dataSortKey: '',
            dataSortDirection: '',
            dataGenre: null,
            dataProductionId: null,

            loading: true,
            data: null,
            event: null,
        }
    },
    // The computed property holds reactive properties for orderItems, filterItems and the queryModel are kept track of.
    computed: {
        orderItems() {
            if (!this.dataSortKey && !this.dataSortDirection) return [];
            return [
                {
                    Key: this.dataSortKey,
                    Direction: this.dataSortDirection,
                }
            ]
        },
        filterItems() {
            if (!this.dataGenre) return [];
            return [{
                Key: 'genres.name',
                Values: [this.dataGenre],
                Operator: 'In',
            }]
        },
        queryModel() {
            return {
                OrderItems: this.orderItems,
                FilterItems: this.filterItems,
            }
        },
        filteredItems() {
            if (!this.data || !this.data.items || !this.data.items.length) return [];
            return this.data.items.filter(item => item.productionProviderId !== this.dataProductionId).slice(0, 3);
        }
    },
    methods: {
        // The fetchData method fetches and handles API data. 
        fetchData() {
            axios
                .post(this.dataApi, this.queryModel)
                .then(response => {
                    this.data = response.data;
                })
                .catch(error => console.log(error))
                // Set loading prop to false when done.
                .finally(() => {
                    this.loading = false;
                            
                });
        },
        redirect(url) {
            if (url) window.location.href = url;
        },
        toMediaQuery(mediaString) {
            if (!mediaString) return '';
            return mediaString.split('"')[1];
        },
        reverse(array) {
            return [...array].reverse();
        },
        // Simple date string handler for date.
        toDateStr(dateString) {
            return new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
        },
    },
    mounted() {
        // Set data props according to data attributes in HTML template.
        if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
        if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
        if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
        if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
        if (this.$el.dataset.genre) this.dataGenre = this.$el.dataset.genre;
        if (this.$el.dataset.productionid) this.dataProductionId = this.$el.dataset.productionid;

        // Initial data fetch.
        this.fetchData();
    },
};

export default recommendationsApp;
